import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";
import { trackEvent, EVENTS } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NotifyForm = ({ dark = true }) => {
  const [email, setEmail] = useState("");
  const [platform, setPlatform] = useState("both");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/notify`, { email, platform });
      trackEvent(EVENTS.launchNotifySubmitted, { platform });
      setDone(true);
      toast.success("You're on the list. We'll email you the moment CoachER launches.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "That email doesn't look right. Try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid="launch-notify-success" className="flex items-center gap-3 rounded-lg border border-white/20 bg-white/5 px-5 py-4">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-coacher-red">
          <Check size={16} className="text-white" />
        </span>
        <p className={dark ? "text-sm text-white/85" : "text-sm text-coacher-slate"}>
          Roster spot saved. We'll notify <span className="font-semibold text-white">{email}</span> at launch.
        </p>
      </div>
    );
  }

  return (
    <form data-testid="launch-notify-form" onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="coach@yourteam.com"
        data-testid="launch-notify-email-input"
        className="h-12 flex-1 rounded-md border border-white/25 bg-white/10 px-4 text-sm text-white placeholder:text-white/40 outline-none transition-colors focus:border-coacher-red"
      />
      <select
        value={platform}
        onChange={(e) => setPlatform(e.target.value)}
        data-testid="launch-notify-platform-select"
        className="h-12 rounded-md border border-white/25 bg-white/10 px-3 text-sm text-white outline-none focus:border-coacher-red [&>option]:text-coacher-navy"
      >
        <option value="ios">iOS</option>
        <option value="android">Android</option>
        <option value="both">Both</option>
      </select>
      <button
        type="submit"
        disabled={loading}
        data-testid="launch-notify-submit-button"
        className="inline-flex h-12 items-center justify-center gap-2 rounded-md bg-coacher-red px-6 text-sm font-semibold text-white transition-colors duration-200 hover:bg-coacher-red-dark disabled:opacity-60"
      >
        {loading ? "Saving..." : "Notify Me at Launch"} <ArrowRight size={16} />
      </button>
    </form>
  );
};

export default NotifyForm;
